import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import store from './store';
import './plugins/router';
import './plugins/vue-svg-icon';
import './plugins/vue-moment';
import './plugins/vue-fragment';
import './plugins/v-mask';
// include roboto font
import './sass/fonts.css';
// include material design icons
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader
import {ERROR_SERVICE_INSTANCE} from '@/services/error.service';
import 'vue-class-component/hooks';
import {ROUTER_SERVICE} from '@/services/router.service'; // import hooks type to enable auto-complete
import './plugins/apex-charts';

Vue.config.productionTip = false;
const router = ROUTER_SERVICE.getInstance();

Vue.config.errorHandler = (err, vm, info) => {
    ERROR_SERVICE_INSTANCE.reportError({
        message: err.message,
        route: router.currentRoute.fullPath,
        name: err.name,
        stack: err.stack || '',
        info,
        timestamp: new Date().toISOString()
    });
};

new Vue({
    vuetify,
    router,
    store,
    render: (h) => h(App),
    beforeCreate() {
        /**
         * Called synchronously immediately after the instance has been initialized,
         * before data observation and event/watcher setup.
         */
        this.$store.commit('restoreStoreState');
    },
    created() {
        /**
         * Called synchronously after the instance is created.
         * At this stage, the instance has finished processing the options which means the following have been set up:
         * data observation, computed properties, methods, watch/event callbacks.
         * However, the mounting phase has not been started, and the $el property will not be available yet.
         */
        this.$vuetify.theme.dark = this.$store.state.theme.dark;
        if (this.$vuetify.theme.dark) {
            document.body.style.backgroundColor = '#353535';
        } else {
            document.body.style.backgroundColor = '#fff';
        }
        document.documentElement.style.setProperty('color-scheme', this.$vuetify.theme.dark ? 'dark' : 'light');
    }
}).$mount('#app');
